export default "__VITE_ASSET__DjGzhwn2__"